import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vendora_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail.problems) return detail.problems.join(" · ");
  return detail.msg || JSON.stringify(detail);
}

export const inr = (n) =>
  `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export const fileUrl = (p) =>
  p && p.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${p}` : p;

export default api;
